
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#FFF","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M2.5 2.5h18v10h-18zm5.367 10l1.157 2h5.415l1.094-2H7.867zm0-10l1.157-2h5.415l1.094 2H7.867z"}}),_c('path',{attrs:{"d":"M11.688 14.5v3.747","stroke-linecap":"square"}}),_c('path',{attrs:{"d":"M12 15l2.938 3.747m-4-3.747L8 18.747m3.688-4.247v4.578","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M1.457 2H21.12M1.457 13H21.12","stroke-linecap":"square"}})])])
          )
        }
      }
    